export default __webpack_public_path__ + "static/cover-1-cewek-46cc9b70be4b3da8b6cc2a8307d587bf.webp";